import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  card: {
    height: "500px",
    width: "500px",
    margin: "50px auto 50px auto",
    display: "table-cell",
    verticalAlign: "middle",
    textAlign: "center",
    "@media (min-width: 1900px)": {
      width: "700px",
      height: "800px",
    },
    "@media (max-width: 550px)": {
      width: "400px",
      height: "500px",
    },
    "@media (max-width: 450px)": {
      width: "300px",
      height: "500px",
    },
    "@media (max-width: 325px)": {
      width: "250px",
      height: "500px",
    },
  },
  column: {
    display: "flex",
    flexDirection: "column",
    margin: "auto auto auto auto",
  },
  submitButton: {
    width: "30%",
    margin: "10px auto auto auto",
  },
  editTextField: {
    width: "80%",
    margin: "10px auto auto auto",
  },
  phoneTextField: {
    width: "80%",
    margin: "10px auto auto auto!important",
  },
  margin: {
    display: "inline-block",
    width: "90%",
    height: "80%",
  },
  header: {
    margin: "5px 0px",
  },
  greeting: {
    width: "80%",
    margin: "10px auto auto auto",
    "@media (min-width: 1900px)": {
      fontSize: "1.5rem",
    },
  },
  dropDownContainer: {
    maxHeight: "400px",
  },
  submission: {
    marginTop: "10px",
  },
});
